module.exports = __webpack_public_path__ + "static/wro-1e45df1abbbf5cc9f88849b0fcf5ae77.png";